import { render, staticRenderFns } from "./subscriptionConfig.vue?vue&type=template&id=788c4d1c&scoped=true"
import script from "./subscriptionConfig.vue?vue&type=script&lang=js"
export * from "./subscriptionConfig.vue?vue&type=script&lang=js"
import style0 from "./subscriptionConfig.vue?vue&type=style&index=0&id=788c4d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c4d1c",
  null
  
)

export default component.exports